import { Editor } from '@tinymce/tinymce-react';
import { ThemeContext } from 'contexts';
import { Box, BoxProps, FormErrorMessageProps } from '@chakra-ui/react';
import { FormErrorMessage } from 'components/UI/forms';
import './Wysiwyg.css';
import { bodyFont } from 'constants/theme';
import { ISettings } from 'types';

export type WysiwygProps = {
  onChange?: (name: string, value?: string) => void;
  name: string;
  error?: string;
  errorProps?: FormErrorMessageProps;
  variant: 'filled' | 'bare';
  value?: string;
  placeholder?: string;
  wrapperProps?: BoxProps;
};

const Wysiwyg = ({ onChange, error, name, variant = 'filled', errorProps, wrapperProps, ...props }: WysiwygProps) => (
  <ThemeContext.Consumer>
    {(theme: ISettings | null) => {
      const primary = theme?.primary1 ?? '#ea8d32';

      const contentStyle = `body { font-family: ${bodyFont}; color: ${
        theme?.primaryText2 ?? '#666666'
      } } a { color: ${primary}; text-decoration: none; } .mce-content-body [data-mce-selected=inline-boundary] { background-color: ${primary}; color: ${
        theme?.primaryText ?? '#fff'
      }; } ::selection { background: #E2E8F0; }`;
      return (
        <Box
          {...wrapperProps}
          h={wrapperProps?.height ?? wrapperProps?.h ?? 200}
          className={`var-wysiwyg var-wysiwyg--${variant}`}
        >
          <Editor
            {...props}
            tinymceScriptSrc="https://cdn.variantconfigurator.com/tinymce/tinymce.min.js"
            init={{
              skin: 'variant',
              height: '100%',
              menubar: false,
              statusbar: false,
              branding: false,
              resize: false,
              plugins: 'anchor link',
              content_style: contentStyle,
              toolbar: 'undo redo styleselect bold italic alignleft aligncenter alignright alignjustify link',
            }}
            onEditorChange={(value) => onChange?.(name, value)}
          />
          <FormErrorMessage {...errorProps}>{error}</FormErrorMessage>
        </Box>
      );
    }}
  </ThemeContext.Consumer>
);

export { Wysiwyg };
